export const TOASTER_TITLE = {
  error: 'Error',
  permissions: {
    denied: 'Permission denied',
  },
  login: {
    error: 'Login error',
  },
  dataApi: {
    error: 'Data API',
  },
};

export const TOASTER_MESSAGE = {
  fetchData: {
    error: {
      subjectArea: 'Subject area data could not be loaded',
      dimensions: 'Dimension data could not be loaded',
      filtersNotLoaded: 'Filters could not be loaded',
      someFiltersNotLoaded: 'Some filters could not be loaded',
      generalError: 'Data could not be loaded',
    },
  },
  auth: {
    error: {
      default: 'Please, login again',
    },
  },
  applicationSettings: {
    error: {
      retrieving: 'Error retrieving application settings',
    },
  },
  branding: {
    success: {
      save: 'Branding changed',
      loadFile: 'File loaded',
    },
    error: {
      save: 'Branding could not be updated',
      loadFile: 'Error on loading file',
      wrongFormat: 'The file should be a JSON',
    },
  },
  kpi: {
    success: {
      update: 'KPI updated',
      add: 'KPI added',
      delete: 'KPI deleted',
      principalKPI: 'KPI is now principal',
    },
    error: {
      update: 'KPIs could not be updated',
      add: 'KPIs could not be updated',
      delete: 'KPI could not be deleted',
      alreadyHavePrincipal: 'Already Have a principal KPI',
      principalError: 'Could not make this a principal KPI',
    },
  },
  dashboardsConfig: {
    success: {
      saveDashboard: 'Dashboard saved',
      saveTile: 'Tile info saved',
      deletedTile: 'Tile deleted',
      deletedDashboard: 'Dashboard deleted',
    },
    error: {
      saveDashboard: 'Dashboard could not be saved',
      deletedDashboard: 'Dashboard could not be deleted',
      addItemError: 'Item cannot be placed in the dashboard',
    },
  },
  subjectArea: {
    success: {
      save: 'Subject area changed',
      delete: 'Subject area deleted',
      deleteLayout: 'Layout deleted',
    },
    error: {
      subjectAreaNotFound: 'Subject Area not found',
      save: 'Subject area could not be changed',
      delete: 'Subject area could not be deleted',
      deleteLayout: 'Layout could not be deleted',
      noKpiExist: 'KPI not found',
      layoutNotNavigable: 'Dashboard is not fully configured.',
      layoutWithoutKpis: 'Dashboard is not fully configured: Missing KPIs',
      layoutWithoutDashboard:
        'Dashboard is not fully configured: Missing charts configuration',
      layoutTypeMapWithoutDimension:
        'Main dashboard is not fully configured: Missing dimension in map configuration',
      layoutTypeMapWithoutRegions:
        'Main dashboard is not fully configured: Missing regions in map configuration',
      layoutTypeMapWithoutCountries:
        'Main dashboard is not fully configured: Missing countries in one of its regions',
    },
  },
  layout: {
    error: {
      nonExistentLayout: 'Dashboard not found',
      customDashboardNotFullyConfigured:
        'Dashboard is not fully configured: Missing charts configuration',
      powerBiDashboardNotFullyConfigured:
        'Dashboard is not fully configured: Missing Power BI report configuration',
      kpiDashboardNotFullyConfigured:
        'Dashboard is not fully configured: Missing KPI configuration',
    },
  },
  kpisTiles: {
    info: {
      noDashboard: 'No dashboard available',
    },
    error: {
      loadData: 'Data could not be loaded',
      notFound: 'KPI not found',
      dashboardNotFullyConfigured:
        'Dashboard is not fully configured: Missing charts configuration',
    },
    actualComparison: {
      title: 'Not available',
      notApplicable: 'No KPI with actual comparison configured',
      noData: 'No KPI with data for actual comparison',
    },
    previousYear: {
      title: 'Not available',
      notApplicable: 'YoY configuration missing.',
      noData: 'No YoY data available.',
      noFilter: `Any year needs to be selected to show YoY data.`,
    },
  },
  collaboration: {
    success: {
      sendEmail: 'Email sent',
      sendTeamsMessage: 'Teams message sent',
    },
    error: {
      sendEmail: 'Email could not be sent',
      sendTeamsMessage: 'Teams message could not be sent',
    },
  },
  screenshot: {
    error: {
      notCaptured: 'Could not take the screenshot',
    },
  },
  filters: {
    success: {
      update: 'Filter updated',
      add: 'Filter added',
      delete: 'Filter deleted',
    },
    error: {
      update: 'Filter could not be updated',
      add: 'Filter could not be added',
      delete: 'Filter could not be deleted',
      cannotLoad: 'Cannot load filter',
    },
  },
  filtersGroup: {
    success: {
      update: 'Group updated',
      add: 'Group added',
    },
    error: {
      update: 'Group could not be updated',
      add: 'Group could not be added',
      delete: 'Group could not be deleted',
    },
  },
  users: {
    success: {
      update: 'User updated',
      add: 'User added',
      delete: 'User deleted',
    },
  },
  subjectAreaFilters: {
    success: {
      update: 'Subject area Filters updated',
    },
    error: {
      update: 'Subject area Filters could not be updated',
    },
  },
  layoutFilters: {
    success: {
      update: 'Layout Filters updated',
    },
    error: {
      update: 'Layout Filters could not be updated',
    },
  },
  graphApi: {
    error: {
      getToken: 'Error in Microsoft authentication',
    },
  },
  msal: {
    error: {
      tokenNotFound:
        'Microsoft authentication error. Please contact your administrator',
    },
  },
  login: {
    error: {
      loginOrApi:
        'Error connecting to Observation Deck API. Please contact your administrator.',
    },
  },
  mapConfiguration: {
    error: {
      notFound: 'No configuration found for layout id',
    },
  },
  userSettings: {
    error: {
      update: 'User settings could not be updated.',
    },
  },
  httpRequest: {
    error: {
      failedConnection: 'Failed to connect to server.',
      wrongRequest: 'Something went wrong with the request.',
    },
  },
  voiceStart: {
    success: {
      start: 'Voice recognition started',
      stop: 'Voice recognition stopped',
    },
  },
  navigation: {
    error: {
      dashboardWithoutKpi: 'Dashboard not configured: missing KPI',
    },
  },
  permissions: {
    error: {
      microphone:
        'Microphone permission needed. Please allow it in the navigator configuration.',
    },
  },
  connectionHistory: {
    success: 'Disconnected successfully',
    error: 'Cannot disconnect',
  },
  subjectAreaGroup: {
    error: `Access denied: You don't have permission to enter this subject area.`,
  },
  layoutAlreadySelected: {
    error: 'You are already viewing this dashboard.',
  },
  landing: {
    noRedirections: {
      error: 'No dashboard or landing page linked to this tile.',
    },
    landingItemPermissions:
      'Access denied: You cannot view any items on this page.',
    notAccessible: 'Landing page not accessible',
  },
  favourite: {
    added: 'Added to My Favorites',
    removed: 'Removed from My Favorites',
    error: 'The action could not complete',
  },
  undo: {
    success: 'Undo action completed successfully',
    error: 'Undo action failed',
  },
  dataApi: {
    error: 'Not connected',
  },
};
